
/**
 * Select random country specific image (based on html lang) and organize smooth transition when loading.
 * Used http://matkl.github.io/average-color/ for average color in html
 */

export default {

    conf: {
        identifier: '[data-cover-bg]',
        activeLang: document.documentElement.lang,
    },

    init: function() {
        let container = $(this.conf.identifier).first();

        if (container) {

            let langImages = container.find("img[data-lang='" + this.conf.activeLang + "']");

            // Fall back to all images if no images with matching lang found
            langImages = langImages.length ? langImages : container.find("img[data-lang]");

            let randomImage = langImages.eq(Math.floor(Math.random() * langImages.length));

            randomImage.addClass('c-cover-bg__img c-cover-bg__img--small');
            randomImage.css('background-color', randomImage.data('averageColor'));
            randomImage.attr('src', randomImage.data('smallSrc'));

            let fullImage = $(new Image()).addClass('c-cover-bg__img c-cover-bg__img--large').appendTo(container);

            fullImage.on('load', () => {
                fullImage.addClass('c-cover-bg__img--loaded');
            })

            fullImage.attr('src', randomImage.data('src'));
        }

    },

}
